var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex w-50 h-100 p-3 mx-auto flex-column p-5 my-5 bg-light rounded shadow-sm"},[_c('h1',[_vm._v("Uh-Oh! 😱")]),_c('h3',[_vm._v("Det är problem med nätverket. "),_c('router-link',{attrs:{"to":{ name: 'guide' }}},[_vm._v("Ladda om sidan")]),_vm._v(" eller försök igen om en stund.")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }